import React from 'react';
import '../../styles/CaseStudyTwo/CaseStudiesBeginning2.css';
import productIcon1 from '../../assets/magnifying-glass-icon.png';
import productIcon2 from '../../assets/salesforce.png';
import productIcon3 from '../../assets/purple-a.png';

const SectionBeginning2 = () => {
  return (
    <section className="beginning-section2">
      <div className="beginning-container2">
        {/* Title */}
        <h2 className="beginning-title2">The Beginning</h2>

        {/* Product/Service Boxes */}
        <div className="product-service-container2">
          <div className="product-service-box2">
            <img src={productIcon1} alt="Product 1" className="beginning-product-icon2" />
            <p>End-To-End Tracking</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon2} alt="Product 2" className="beginning-product-icon2" />
            <p>Salesforce CRM Data Integration</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon3} alt="Product 3" className="beginning-product-icon2" />
            <p>Google Ads Optimization</p>
          </div>
        </div>

        {/* Description Text */}
        <p className="beginning-description2">
          John Volken Academy Movers, base in Kent, Washington, and Phoenix, Arizona, offers high-quality moving services. 
          To improve the efficiency of their Google Ads campaigns, we implemented End-To-End Tracking. This system pulls key data from their Salesforce CRM and feeds it back into Google Ads. 
          With this real-time data, we were able to identify which clicks, campaigns, and keywords resulted in scheduled moves and valid leads.
           By focusing on actual moves instead of leads alone, we optimized their marketing spend for meaningful results.
        </p>

      </div>
    </section>
  );
};

export default SectionBeginning2;

